import React from "react";

export default function SQLServer_ASIN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_ASIN</h1>
      <p>This is the SQLServer_ASIN component generated from the SQL JSON.</p>
    </div>
  );
}
